import { graphql } from "react-relay";

export const AddPolicyCollectionItemsMutation = graphql`
  mutation AddPolicyCollectionItemsMutation(
    $input: PolicyCollectionItemsInput!
  ) {
    addPolicyCollectionItems(input: $input) {
      collection {
        policyMappings {
          pageInfo {
            total
          }
        }
        uuid
      }
    }
  }
`;
